import { getContextText } from './getContextText';
import { storeNotification } from './notificationCache';
import { NOTIFICATION_PREFERENCES_ACTION_ID } from './constants';
// @ts-expect-error bender imports are untyped
import notificationsBadge from 'bender-url!../../../img/notifications-badge.png';
// @ts-expect-error bender imports are untyped
import notificationsIcon from 'bender-url!../../../img/notifications-icon.png';
/**
 * Creates arguments for a browser Notification constructor or service worker showNotification call
 */
export const createNotificationArgs = (browserNotification, includePreferencesAction) => {
  const {
    id,
    portalId,
    translatedTemplate: {
      body,
      subject
    },
    type,
    userLanguage
  } = browserNotification;
  const tag = `${id}`;
  // We don't have translations in the service worker at this time, don't add the action without a local title
  // historically an English title was always used
  const hasPreferenceAction = includePreferencesAction && userLanguage === 'en';
  const contextText = getContextText(browserNotification);
  const bodyText = contextText || body;
  storeNotification(browserNotification, hasPreferenceAction ? {
    [NOTIFICATION_PREFERENCES_ACTION_ID]: `/notification-preferences/${portalId}/?highlight=${type}`
  } : {});
  const options = {
    actions: hasPreferenceAction ? [{
      action: NOTIFICATION_PREFERENCES_ACTION_ID,
      title: 'HubSpot notification preferences'
    }] : [],
    badge: notificationsBadge,
    body: bodyText,
    icon: notificationsIcon,
    tag
  };
  return [subject, options];
};